import './HeroPointChip.css';

/**
 * A6 — Styled "[H]" chip used by HeroPointChipPortal during the
 * spend dispatch animation. Pure presentational: no animation,
 * no logic. The portal wraps it in framer-motion to fly across
 * the viewport from PC portrait → roll result card.
 *
 * The chip is also rendered statically (no portal) in the spend
 * affordance button next to the PC's hero-point count for visual
 * consistency.
 */
export interface HeroPointChipProps {
  /** Visual variant. 'standard' is the default chip; 'large' is used
   *  by the portal mid-flight to read at a distance. */
  variant?: 'standard' | 'large';
  /** Optional testid; default 'br-hero-point-chip'. */
  testid?: string;
}

export function HeroPointChip({
  variant = 'standard',
  testid = 'br-hero-point-chip',
}: HeroPointChipProps) {
  return (
    <div
      className={`br-hero-point-chip br-hero-point-chip-${variant}`}
      data-testid={testid}
      data-variant={variant}
      aria-hidden="true"
    >
      <span className="br-hero-point-chip-bracket">[</span>
      <span className="br-hero-point-chip-letter">H</span>
      <span className="br-hero-point-chip-bracket">]</span>
    </div>
  );
}

export default HeroPointChip;
